import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormMultiSelect from "../form/FormMultiSelect";
import TmwApi from "../../containers/Ticket/TmwApi";

class TmwCustomerSelect extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			billToCustomers: [],
		};
	}
	componentDidMount() {
		const { getBillToCustomerList } = this.props;

		getBillToCustomerList({
			callback : (err, r) => {
				if (err) { return console.error(err); }
				this.setState({ billToCustomers : r.billToCustomers });
			}
		});
	}

	render () {
		let { value, billToFilter } = this.props;
		const { billToCustomers = []} = this.state;
		const filter = (billToFilter) ? _.keyBy(billToFilter) : undefined;

		let options = billToCustomers.map((billToCustomer) => {
			const { ord_billto, billToCompany} = billToCustomer;
			if (filter && !filter[ord_billto]) {
				// gets rid of previously selected values
				if (_.isArray(value) && _.includes(value, ord_billto)) {
					value = _.remove(value, ord_billto);
				}
				return null;
			}

			return {
				value: ord_billto,
				display: `${billToCompany} (${ord_billto})`,
			};
		});

		options = _.sortBy(_.compact(options), 'display');

		return (
			<FormMultiSelect
				{...this.props}
				// so an empty thing doesn't flicker in
				value={_.isEmpty(billToCustomers) ? [] : value}
				options={options}
			/>
		);
	}
}

TmwCustomerSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.array,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	getBillToCustomerList : PropTypes.func.isRequired,

	classes : PropTypes.object,
	helpText : PropTypes.string,
	billToFilter : PropTypes.array,
};

TmwCustomerSelect.defaultProps =  {
	label : 'Bill To Customer',
	billToCustomers : [],
};

export default TmwApi(TmwCustomerSelect);
